ImageEnteteValidator.$inject = ['validator'];

export default function ImageEnteteValidator(validator) {
	const instance = new validator();
	instance.ruleFor('code').notEmpty().when(isNotCodeAuto).withMessage('VALIDATION_NOTEMPTY');
	instance.ruleFor('idType').notEmpty().withMessage('VALIDATION_NOTEMPTY');
	instance.ruleFor('libelle').notEmpty().withMessage('VALIDATION_NOTEMPTY');
	instance.ruleFor('libelle').length(1, 100).withMessage('VALIDATION_TOO_LONG_DESCRIPTION');
	instance.ruleFor('downloadFile').fileTooBig(2000000).when(isNotCodeAuto).withMessage('FILE_TOO_LARGE');

	return instance;

	function isNotCodeAuto(obj, prop) {
		return !obj.isCodeAutoEnabled;
	}
}
